import { Phone, Mail, Clock, MapPin, Facebook } from "lucide-react";
import { LOGO_URL } from "@/constants/assets";

const Footer = () => (
  <footer className="bg-[#1A1A1A] text-white border-t border-white/10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 md:py-20">
      <div className="grid md:grid-cols-[1.2fr_1fr_1fr] gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src={LOGO_URL} alt="Tidy Tusks" className="h-14 w-14 object-contain bg-[#FAF7F2] rounded-2xl p-1.5" />
            <span className="font-display font-bold text-2xl tracking-tight">Tidy <span className="text-[#E8B4B8]">Tusks</span></span>
          </div>
          <p className="text-sm text-white/60 leading-relaxed max-w-sm">
            Professional residential & commercial cleaning with Razorback tenacity. Spotless spaces, zero stress, guaranteed.
          </p>
          <p className="font-display italic text-lg text-white/80 mt-6">"Pristine spaces. Exceptional care."</p>
          <a
            href="https://www.facebook.com/share/1DYdcYALC1/?mibextid=wwXIfr"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-facebook-link"
            className="mt-6 inline-flex items-center gap-2.5 bg-[#990000] text-white text-sm font-semibold py-2.5 px-5 rounded-full shadow-md hover:bg-[#7A0000] hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200"
          >
            <Facebook size={16} /> Follow us on Facebook
          </a>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37] mb-5">Contact</h4>
          <ul className="space-y-3.5 text-sm text-white/75">
            <li><a href="tel:9185750005" data-testid="footer-call-link" className="flex items-center gap-2.5 hover:text-[#E8B4B8] transition-colors duration-200"><Phone size={15} className="text-[#E8B4B8]" /> (918) 575-0005</a></li>
            <li><a href="mailto:ttprofessionalcleaners@gmail.com" data-testid="footer-email-link" className="flex items-center gap-2.5 hover:text-[#E8B4B8] transition-colors duration-200"><Mail size={15} className="text-[#E8B4B8]" /> ttprofessionalcleaners@gmail.com</a></li>
            <li className="flex items-center gap-2.5"><Clock size={15} className="text-[#E8B4B8]" /> Mon–Sat, 8am–6pm</li>
            <li className="flex items-center gap-2.5"><MapPin size={15} className="text-[#E8B4B8]" /> Fayetteville · Springdale · Rogers · Bentonville</li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37] mb-5">Services</h4>
          <ul className="space-y-3.5 text-sm text-white/75">
            {["Residential Maintenance", "Deep Cleaning", "Move-In / Move-Out", "Post-Construction"].map((s) => (
              <li key={s}><a href="#services" className="hover:text-[#E8B4B8] transition-colors duration-200">{s}</a></li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 mt-14 pt-7 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/45">
        <span>© {new Date().getFullYear()} Tidy Tusks Professional Cleaning Services. All rights reserved.</span>
        <span>Locally owned & operated in Northwest Arkansas</span>
      </div>
      <p data-testid="footer-powered-by" className="text-center text-[11px] text-white/35 mt-5 tracking-wide">
        Powered by <a href="https://www.tybra.digital" target="_blank" rel="noopener noreferrer" data-testid="footer-tybra-link" className="hover:text-[#E8B4B8] underline underline-offset-2 transition-colors duration-200">Tybra Digital</a>
      </p>
    </div>
  </footer>
);

export default Footer;
